(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-intro-sparkle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'ms-fx-shown';
    var NS = 'http://www.w3.org/2000/svg';
    var STAR4 = 'M12 0C13 7.5 16.5 11 24 12 16.5 13 13 16.5 12 24 11 16.5 7.5 13 0 12 7.5 11 11 7.5 12 0z';
    var STAR5 = 'M12 1.5l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.6 5.6 21.1 7 14l-5.3-5 7.2-.9z';
    var PAL = {
      peri: ['#F6C667', '#F4A261', '#B9A7F5', '#F7A8B8', '#FFE7A8'],
      konfeti: ['#E30A17', '#FFFFFF', '#E30A17', '#F6C667', '#FFFFFF'],
      kar: ['#FFFFFF', '#EAF2FF', '#FFFFFF', '#DDE7FA', '#FFFFFF']
    };
    function run(root) {
      if (root.dataset.msInit) return;
      root.dataset.msInit = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var inEditor = window.Shopify && window.Shopify.designMode;
      if (root.dataset.once === 'true' && !inEditor) {
        try { if (sessionStorage.getItem(KEY)) return; sessionStorage.setItem(KEY, '1'); } catch (e) {}
      }
      var mode = root.dataset.mode || 'peri', cols = PAL[mode] || PAL.peri;
      var W = window.innerWidth, H = window.innerHeight;
      var n = parseInt(root.dataset.count, 10) || 30;
      if (W < 750) n = Math.max(8, Math.round(n * 0.7));
      var DUR = parseInt(root.dataset.duration, 10) || 5500;
      var P = [];
      for (var i = 0; i < n; i++) {
        var c = cols[i % cols.length], el, s;
        if (mode === 'kar') {
          el = document.createElement('i'); s = 4 + Math.random() * 7;
          el.style.width = s + 'px'; el.style.height = s + 'px'; el.style.background = c; el.style.boxShadow = '0 0 6px rgba(150,170,210,.6)';
        } else if (mode === 'konfeti') {
          el = document.createElement('i'); s = 6 + Math.random() * 6;
          el.style.width = s + 'px'; el.style.height = (s * 0.45) + 'px'; el.style.borderRadius = '2px'; el.style.background = c;
          if (c === '#FFFFFF') el.style.boxShadow = '0 0 0 1px rgba(227,10,23,.25)';
        } else {
          el = document.createElementNS(NS, 'svg'); el.setAttribute('viewBox', '0 0 24 24');
          var p = document.createElementNS(NS, 'path'); p.setAttribute('d', i % 4 === 3 ? STAR5 : STAR4); p.setAttribute('fill', c);
          el.appendChild(p); s = (W < 750 ? 13 : 15) + Math.random() * (i % 5 === 0 ? 20 : 11);
          el.style.width = s + 'px'; el.style.height = s + 'px';
        }
        root.appendChild(el);
        P.push({ el: el, x0: Math.random() * W, y0: -30 - Math.random() * H * 0.25, delay: Math.random() * DUR * 0.45,
          fall: DUR * (0.5 + Math.random() * 0.4), sway: (mode === 'kar' ? 20 : 26) + Math.random() * 40, spin: (Math.random() - 0.5) * (mode === 'konfeti' ? 900 : 220),
          tw: 3 + Math.random() * 5, ph: Math.random() * 6.28, drop: mode === 'peri' ? 0.75 : 1 });
      }
      var start = performance.now();
      function frame(now) {
        var t = now - start;
        for (var i = 0; i < P.length; i++) {
          var q = P[i], u = (t - q.delay) / q.fall;
          if (u < 0 || u > 1) { q.el.style.opacity = 0; continue; }
          var y = q.y0 + u * (H + 80) * q.drop, x = q.x0 + Math.sin(u * 5 + q.ph) * q.sway, r = q.spin * u;
          var a = u < 0.1 ? u / 0.1 : (u > 0.8 ? (1 - u) / 0.2 : 1);
          var sc = 1;
          if (mode === 'peri') { var tw = 0.55 + 0.45 * Math.abs(Math.sin(u * q.tw * 3.14 + q.ph)); a *= tw; sc = 0.7 + 0.5 * tw; }
          if (mode === 'konfeti') { sc = 1; }
          q.el.style.opacity = a;
          q.el.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + r + 'deg) scale(' + sc + ')' + (mode === 'konfeti' ? ' rotateX(' + (Math.sin(u * 14 + q.ph) * 70) + 'deg)' : '');
        }
        if (t < DUR + 300) requestAnimationFrame(frame); else { root.innerHTML = ''; window.msFxDone = true; document.dispatchEvent(new CustomEvent('ms:fx:done')); }
      }
      requestAnimationFrame(frame);
    }
    /* start right after the 0.8 s page loader instead of waiting for window.load (videos can delay it by seconds) */
    function initAll() { document.querySelectorAll('[data-ms-fx]').forEach(function (r) { setTimeout(function () { run(r); }, 900); }); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.msbInit) return;
      root.dataset.msbInit = '1';
      var items = root.querySelectorAll('.msb-ann__item');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, 3500);
    }
    function initAll() { document.querySelectorAll('[data-msb-ann]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-bottom-nav"]) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-msb-bn2]');
    if (!nav || nav.dataset.msbInit) return;
    nav.dataset.msbInit = '1';
    var m = nav.querySelector('[data-msb-bn2-menu]');
    if (m) m.addEventListener('click', function () {
      if (window.msbOpenMenu) window.msbOpenMenu();
      else { var s = document.querySelector('summary.header__icon--menu'); if (s) s.click(); }
    });
    var sw = document.querySelector('[data-msb-srch]'), sb = nav.querySelector('[data-msb-bn2-search]');
    if (sw && sb) {
      var inp = sw.querySelector('[data-msb-srch-input]'), res = sw.querySelector('[data-msb-srch-res]'), pop = sw.querySelector('[data-msb-srch-pop]'), all = sw.querySelector('[data-msb-srch-all]');
      var timer, ctl, fmt = function (v) { return Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; };
      var esc = function (x) { var d = document.createElement('div'); d.textContent = x == null ? '' : String(x); return d.innerHTML; };
      // Typewriter placeholder: types and erases sample searches until the shopper focuses the field (keyboard only on tap).
      var words = ['Uyku masalı', 'Meslek kitabı', 'Süper kahraman masalı', 'Doğum günü hediyesi', 'Boyama kitabı'];
      var tw = null, wi = 0, ci = 0, del = false, base = 'Ara: ';
      var tick = function () {
        var w = words[wi % words.length];
        ci += del ? -1 : 1;
        inp.setAttribute('placeholder', base + w.slice(0, ci) + (ci < w.length || del ? '|' : ''));
        var wait = del ? 35 : 75;
        if (!del && ci >= w.length) { del = true; wait = 1400; }
        else if (del && ci <= 0) { del = false; wi++; wait = 350; }
        tw = setTimeout(tick, wait);
      };
      var typeStart = function () { if (tw || inp.value) return; ci = 0; del = false; tw = setTimeout(tick, 450); };
      var typeStop = function (keep) { clearTimeout(tw); tw = null; inp.setAttribute('placeholder', keep ? 'Ne aramıştınız?' : 'Masal, tema veya isim ara…'); };
      inp.addEventListener('focus', function () { typeStop(true); });
      inp.addEventListener('blur', function () { if (!inp.value && sw.classList.contains('is-open')) typeStart(); });
      var open = function () {
        sw.hidden = false; document.documentElement.classList.add('msb-srch-lock');
        requestAnimationFrame(function () { sw.classList.add('is-open'); });
        typeStart();
      };
      var close = function () {
        sw.classList.remove('is-open'); document.documentElement.classList.remove('msb-srch-lock'); inp.blur(); typeStop();
        setTimeout(function () { sw.hidden = true; }, 380);
      };
      var run = function (q) {
        q = q.trim(); if (ctl) ctl.abort();
        if (q.length < 2) { res.innerHTML = ''; all.hidden = true; pop.hidden = false; return; }
        pop.hidden = true; ctl = window.AbortController ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide', ctl ? { signal: ctl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!ps.length) { res.innerHTML = '<li class="msb-srch__msg">"' + esc(q) + '" için sonuç bulunamadı.</li>'; all.hidden = true; return; }
            res.innerHTML = ps.map(function (p) {
              var cmp = Number(p.compare_at_price_max) > Number(p.price) ? '<s>' + fmt(p.compare_at_price_max) + '</s>' : '';
              var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span class="msb-srch__ph"></span>';
              return '<li><a href="' + esc(p.url) + '">' + img + '<span><span class="msb-srch__t">' + esc(p.title) + '</span><span class="msb-srch__p">' + fmt(p.price) + cmp + '</span></span></a></li>';
            }).join('');
            all.href = '/search?type=product&q=' + encodeURIComponent(q); all.textContent = 'Tüm sonuçları gör'; all.hidden = false;
          }).catch(function () {});
      };
      sb.addEventListener('click', function (e) { e.preventDefault(); open(); });
      sw.querySelectorAll('[data-msb-srch-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sw.hidden) close(); });
      var sheet = sw.querySelector('.msb-srch__sheet'), body = sw.querySelector('.msb-srch__body'), y0 = null, dy = 0;
      sheet.addEventListener('touchstart', function (e) { if (body.contains(e.target) && body.scrollTop > 0) { y0 = null; return; } y0 = e.touches[0].clientY; dy = 0; sheet.style.transition = 'none'; }, { passive: true });
      sheet.addEventListener('touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = dy ? 'translateY(' + dy + 'px)' : ''; }, { passive: true });
      sheet.addEventListener('touchend', function () { if (y0 === null) return; sheet.style.transition = ''; sheet.style.transform = ''; if (dy > 90) close(); y0 = null; });
      inp.addEventListener('input', function () { clearTimeout(timer); var v = inp.value; timer = setTimeout(function () { run(v); }, 220); });
      sw.querySelectorAll('.msb-srch__chip').forEach(function (c) { c.addEventListener('click', function () { inp.value = c.dataset.q; run(c.dataset.q); }); });
    }
    try {
      var favs = JSON.parse(localStorage.getItem('msb-favs') || '[]');
      var fb = nav.querySelector('[data-msb-bn2-fav]');
      if (fb && favs.length) { fb.textContent = favs.length; fb.hidden = false; }
    } catch (e) {}
    var last = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > last + 8 && y > 120) nav.classList.add('is-hidden');
        else if (y < last - 8 || y < 120) nav.classList.remove('is-hidden');
        last = y; ticking = false;
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-cart-page"]) return;
  try {
    
  /* 12 Oct: "Tek dokunuşla ekle" — recommends books for the same child (gender collection) and adds one with the first cart line's personalisation copied. */
  (function () {
    var box = document.querySelector('[data-ms-oneri]'); if (!box) return;
    var src = document.querySelector('[data-msb-lp][data-kahraman]:not([data-kahraman=""])');
    var inCart = [].map.call(document.querySelectorAll('[data-msb-lp]'), function (e) { return (e.dataset.productUrl || '').split('/').pop(); });
    var d = src ? src.dataset : null;
    var col = d && d.cinsiyet === 'Kız' ? 'kiz-cocuk-masallari' : (d && d.cinsiyet === 'Erkek' ? 'erkek-cocuk-masallari' : 'cok-satanlar');
    function esc(t) { var x = document.createElement('div'); x.textContent = t == null ? '' : String(t); return x.innerHTML; }
    function shortT(t) { return String(t || '').split(' | ')[0].split(' - ')[0].split(' – ')[0].trim(); }
    function money(v) { return Math.round(v).toLocaleString('tr-TR') + ' TL'; }
    function img(u, w) { return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
    fetch('/collections/' + col + '/products.json?limit=24').then(function (r) { return r.json(); }).then(function (j) {
      var ps = (j.products || []).filter(function (p) { return inCart.indexOf(p.handle) < 0 && p.images && p.images[0] && p.variants && p.variants[0] && p.variants[0].available !== false; }).slice(0, 8);
      if (!ps.length) return;
      var nm = d ? d.kahraman : '';
      box.querySelector('.msb-cartpg__oneri-s').textContent = nm ? (nm + ' için tek dokunuşla eklenir; fotoğraflar ve ithaf aynı kalır.') : 'Çok sevilen masallar.';
      box.querySelector('.msb-cartpg__oneri-row').innerHTML = ps.map(function (p) {
        var t = nm && window.msKw ? window.msKw.cover(p.title, nm) : shortT(p.title);
        return '<div class="ms-or" role="listitem" data-vid="' + p.variants[0].id + '" data-title="' + esc(p.title) + '" data-handle="' + esc(p.handle) + '">' +
          '<a href="/products/' + esc(p.handle) + '"><img src="' + esc(img(p.images[0].src, 300)) + '" alt="" loading="lazy"></a>' +
          '<div class="ms-or__t">' + esc(t) + '</div><div class="ms-or__p">' + money(parseFloat(p.variants[0].price)) + '</div>' +
          (nm ? '<button type="button" class="ms-or__b" data-add>' + esc(nm) + ' için ekle</button><button type="button" class="ms-or__o" data-other>Başka bir çocuk için</button>'
              : '<a class="ms-or__b" href="/products/' + esc(p.handle) + '">Kişiselleştir</a>') +
          '</div>';
      }).join('');
      box.hidden = false;
      if (location.hash === '#ms-oneri') { setTimeout(function () { try { box.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) {} }, 200); }
    }).catch(function () {});
    box.addEventListener('click', function (e) {
      var card = e.target.closest('.ms-or'); if (!card) return;
      if (e.target.closest('[data-other]')) {
        var ov = document.getElementById('ms-wiz-overlay');
        if (ov && window.msWizOpenForVariant) {
          ov.setAttribute('data-kw-title', shortT(card.dataset.title));
          var st = ov.querySelector('.kw-side-t'); if (st) st.textContent = shortT(card.dataset.title);
          var ci = ov.querySelector('.kw-cover img'), im = card.querySelector('img'); if (ci && im) ci.src = im.src;
          window.msWizOpenForVariant(card.dataset.vid);
        } else { location.href = '/products/' + card.dataset.handle; }
        return;
      }
      var btn = e.target.closest('[data-add]'); if (!btn || !d) return;
      btn.disabled = true; btn.textContent = 'Ekleniyor…';
      var props = { 'Kahraman': d.kahraman, 'Cinsiyet': d.cinsiyet };
      (d.photos || '').split('|').filter(function (u) { return u.indexOf('http') === 0; }).slice(0, 5).forEach(function (u, i) { props['Fotoğraf ' + (i + 1)] = u; });
      if (d.hazirlayan) props['Hazırlayan'] = d.hazirlayan;
      if (d.iliski) props['İlişki'] = d.iliski;
      if (d.not) props['Özel Not'] = d.not;
      if (window.msKw) { props['_Kapak'] = window.msKw.cover(card.dataset.title, d.kahraman); props['_Hediye'] = window.msKw.gift(d.kahraman, d.iliski); }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(card.dataset.vid, 10), quantity: 1, properties: props }] }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { btn.textContent = '✓ Eklendi'; btn.classList.add('is-ok'); setTimeout(function () { location.reload(); }, 700); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Tekrar dene'; });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.msbInit) return;
      root.dataset.msbInit = '1';
      var slides = root.querySelectorAll('.msb-hero__slide');
      var dots = root.querySelectorAll('.msb-hero__dot');
      if (slides.length < 2) return;
      var current = 0;
      var timer = null;
      var speed = parseInt(root.dataset.speed, 10) || 5000;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === current;
          s.classList.toggle('is-active', on);
          if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('tabindex'); }
          else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('tabindex', '-1'); }
        });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === current); });
      }
      function start() {
        if (root.dataset.autoplay !== 'true' || reduced) return;
        stop();
        timer = setInterval(function () { go(current + 1); }, speed);
      }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      root.querySelector('.msb-hero__arrow--prev').addEventListener('click', function () { go(current - 1); start(); });
      root.querySelector('.msb-hero__arrow--next').addEventListener('click', function () { go(current + 1); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10)); start(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);

      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); start(); }
        x0 = null;
      });
      start();
    }
    function initAll() { document.querySelectorAll('.msb-hero').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(form) {
      if (form.dataset.msbInit) return;
      form.dataset.msbInit = '1';
      var real = document.getElementById('msb-col-form');
      form.querySelectorAll('[data-msb-col-auto]').forEach(function (el) {
        el.addEventListener('change', function () { real.requestSubmit ? real.requestSubmit() : real.submit(); });
      });
      real.addEventListener('submit', function () {
        form.querySelectorAll('input[type=number]').forEach(function (i) { if (!i.value) i.disabled = true; });
      });
      var panel = form.querySelector('[data-msb-col-panel]');
      var toggle = form.querySelector('[data-msb-col-toggle]');
      var close = form.querySelector('[data-msb-col-close]');
      function set(open) {
        panel.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('msb-noscroll', open);
      }
      if (toggle) toggle.addEventListener('click', function () { set(true); });
      if (close) close.addEventListener('click', function () { set(false); });
    }
    // infinite scroll: load the next page's cards when the visitor nears the end of the grid (the pager stays as a no-JS fallback)
    function infinite(form) {
      var more = form.querySelector('[data-msb-col-more]');
      var grid = form.querySelector('.msb-col__grid');
      if (!more || !grid || !('IntersectionObserver' in window)) return;
      var pages = form.querySelector('.msb-col__pages');
      if (pages) pages.style.display = 'none';
      var busy = false;
      function load() {
        var next = more.dataset.next;
        if (busy || !next) return;
        busy = true; more.classList.add('is-loading');
        fetch(next, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('.msb-col__grid > li').forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          var nm = doc.querySelector('[data-msb-col-more]');
          if (nm && nm.dataset.next) more.dataset.next = nm.dataset.next; else { delete more.dataset.next; more.classList.add('is-done'); }
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        }).catch(function () { if (pages) pages.style.display = ''; }).finally(function () { busy = false; more.classList.remove('is-loading'); var r = more.getBoundingClientRect(); if (more.dataset.next && r.top < window.innerHeight + 900) load(); });
      }
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) load(); }, { rootMargin: '900px 0px' }).observe(more);
    }
    function initAll() { document.querySelectorAll('[data-msb-col-form]').forEach(function (f) { var first = !f.dataset.msbInit; init(f); if (first) infinite(f); }); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-mobile-menu"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-msb-mm]');
    if (!root || root.dataset.msbInit) return;
    root.dataset.msbInit = '1';
    // keep Horizon's own mobile drawer closed (its header icon would otherwise stay in the "X" state)
    function resetHorizon() {
      document.querySelectorAll('header-drawer details, #Details-menu-drawer-container').forEach(function (d) {
        d.classList.remove('menu-open');
        d.removeAttribute('open');
        var sm = d.querySelector('summary');
        if (sm) sm.setAttribute('aria-expanded', 'false');
      });
    }
    function open() {
      [0, 60, 400].forEach(function (t) { setTimeout(resetHorizon, t); });
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      resetHorizon();
      root.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 350);
    }
    window.msbOpenMenu = open;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('summary.header__icon--menu');
      if (!t || window.matchMedia('(min-width: 990px)').matches) return;
      e.preventDefault(); e.stopPropagation();
      open();
    }, true);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-msb-mm-close]')) close(); });
    root.querySelectorAll('[data-msb-mm-acc]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var w = b.parentNode, willOpen = !w.classList.contains('is-open');
        root.querySelectorAll('.msb-mm__row-wrap.is-open').forEach(function (o) { o.classList.remove('is-open'); o.querySelector('[data-msb-mm-acc]').setAttribute('aria-expanded', 'false'); });
        if (willOpen) { w.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    root.querySelectorAll('[data-msb-mm-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-msb-mm-tab]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-selected', x === b); });
        root.querySelectorAll('[data-msb-mm-pane]').forEach(function (p) { p.classList.toggle('is-on', p.dataset.msbMmPane === b.dataset.msbMmTab); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.msbInit) return;
      root.dataset.msbInit = '1';
      var track = root.querySelector('[data-msb-car-track]');
      var btns = root.querySelectorAll('.msb-car__arrow');
      if (!track) return;
      function upd() {
        btns[0].disabled = track.scrollLeft <= 4;
        btns[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: parseInt(b.dataset.dir, 10) * track.clientWidth * 0.8 }); });
      });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
    function initAll() { document.querySelectorAll('[data-msb-car]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function addBizDays(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    function fmt(a, b) {
      if (a.getMonth() === b.getMonth()) return a.getDate() + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
      return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    }
    function money(cents) { var f = cents % 100 ? 2 : 0; return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: f, maximumFractionDigits: f }) + ' TL'; }
    function init(root) {
      if (root.dataset.msbInit) return;
      root.dataset.msbInit = '1';
      var track = root.querySelector('[data-msb-track]');
      // start loading the remaining gallery photos as soon as the visitor touches or scrolls the gallery (no blank slides on swipe)
      // audit C3: warm only the slide after the current one (not the whole gallery) when the visitor touches / swipes
      function slideW() { var c = track && track.children[0]; if (!c) return 1; var g = parseFloat(getComputedStyle(track).columnGap) || 0; return (c.getBoundingClientRect().width + g) || 1; }
      function warm(i) { [i, i + 1].forEach(function (k) { var sl = track.children[k]; var im = sl && sl.querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; }); }
      if (track) ['pointerdown', 'touchstart'].forEach(function (ev) { track.addEventListener(ev, function () { warm(Math.round(track.scrollLeft / slideW()) + 1); }, { passive: true }); });
      var ths = root.querySelectorAll('[data-msb-th]');
      var dots = root.querySelectorAll('.msb-pm__dots i');
      var cur = root.querySelector('[data-msb-cur]');
      var idx = 0;
      function mark(i) {
        idx = i;
        ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
        if (cur) cur.textContent = i + 1;
      }
      if (track) {
        track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / slideW()); mark(i); warm(i + 1); }, { passive: true });
        ths.forEach(function (t) {
          t.addEventListener('click', function () { var i = parseInt(t.dataset.msbTh, 10); warm(i); track.scrollTo({ left: slideW() * i }); });
        });
      }
      // lightbox
      var full = [];
      try { full = JSON.parse(root.querySelector('[data-msb-full]').textContent); } catch (e) {}
      var lb = root.querySelector('[data-msb-lb]');
      var lbImg = root.querySelector('[data-msb-lb-img]');
      var zoom = root.querySelector('[data-msb-zoom]');
      if (zoom && lb && lb.showModal) {
        zoom.addEventListener('click', function () { if (full[idx]) { lbImg.src = full[idx]; lb.showModal(); } });
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-msb-lb-close]')) lb.close(); });
      }
      // quantity
      var qty = root.querySelector('.msb-pm__qty input'); if (!qty) qty = { value: 1 };
      root.querySelectorAll('[data-msb-qty]').forEach(function (b) {
        b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.msbQty, 10)); });
      });
      // ship dates
      var eta = root.querySelector('[data-msb-eta]');
      if (eta) { var n = new Date(); eta.textContent = fmt(addBizDays(n, parseInt(eta.dataset.min, 10)), addBizDays(n, parseInt(eta.dataset.max, 10))); }
      // mobile sticky add-to-cart: visible once the main add button scrolls out of view
      var sticky = root.querySelector('[data-msb-sticky]');
      var add = root.querySelector('[data-msb-add]');
      if (sticky && add && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var off = !en[0].isIntersecting;
          sticky.classList.toggle('is-on', off);
          sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
          var stB = sticky.querySelector('[data-msb-sticky-add]'); if (stB) stB.tabIndex = off ? 0 : -1;
        }).observe(add);
        root.querySelector('[data-msb-sticky-add]').addEventListener('click', function () { if (window.msWizOpen) window.msWizOpen(); });
      }
      // variant options
      var vjson = root.querySelector('[data-msb-variants]');
      if (vjson) {
        var variants = JSON.parse(vjson.textContent);
        var idInput = root.querySelector('[data-msb-variant-id]');
        var now2 = root.querySelector('[data-msb-now]');
        var priceNow = root.querySelector('[data-msb-price-now]');
        var priceWas = root.querySelector('[data-msb-price-was]');
        root.querySelectorAll('[data-msb-opt]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = [];
            root.querySelectorAll('[data-msb-opt]:checked').forEach(function (c) { sel[+c.dataset.msbOpt] = c.value; });
            var lbl = root.querySelector('[data-msb-opt-label="' + inp.dataset.msbOpt + '"]');
            if (lbl) lbl.textContent = inp.value;
            var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
            if (!v) return;
            idInput.value = v.id;
            priceNow.textContent = money(v.price);
            var inst = root.querySelector('[data-msb-inst]'), instN = root.querySelector('[data-msb-inst-n]');
            if (inst && instN) inst.textContent = money(Math.floor(v.price / parseInt(instN.dataset.msbInstN, 10)));
            // main price block + mobile sticky bar follow the selected variant (Reha 30 Sep: sticky price did not update)
            var disc = v.compare_at_price > v.price, pctTxt = disc ? '%' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : '';
            [['[data-msb-price-was]', '[data-msb-price-pct]'], ['[data-msb-st-was]', '[data-msb-st-pct]']].forEach(function (pair) {
              var w = root.querySelector(pair[0]), p = root.querySelector(pair[1]);
              if (w) { w.textContent = disc ? money(v.compare_at_price) : ''; w.hidden = !disc; }
              if (p) { p.textContent = pctTxt; p.hidden = !disc; }
            });
            var stNow = root.querySelector('[data-msb-st-now]'); if (stNow) stNow.textContent = money(v.price);
            var stAdd = root.querySelector('[data-msb-sticky-add]'); if (stAdd) { stAdd.disabled = !v.available; stAdd.textContent = v.available ? (add.dataset.label || 'Sepete Ekle') : 'Tükendi'; }
            add.disabled = !v.available;
            add.textContent = v.available ? (add.dataset.label || 'Sepete Ekle') : 'Tükendi';
            if (now2) now2.hidden = !v.available;
            var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
          });
        });
      }
    }
    function initAll() { document.querySelectorAll('[data-msb-pm]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
  (function () {
    // product video: muted loop while on screen, sound toggle + progress line, full-screen dialog with sound
    function initVid(box) {
      if (box.dataset.msbInit) return;
      box.dataset.msbInit = '1';
      var v = box.querySelector('[data-msb-vid-v]'), d = box.querySelector('[data-msb-vid-d]'), f = box.querySelector('[data-msb-vid-full]');
      var bar = box.querySelector('[data-msb-vid-bar]'), snd = box.querySelector('[data-msb-vid-snd]');
      function play(el) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !d.open) play(v); else v.pause(); }); }, { threshold: 0.3 }).observe(v);
      } else play(v);
      if (bar) v.addEventListener('timeupdate', function () { if (v.duration) bar.style.width = (100 * v.currentTime / v.duration) + '%'; });
      if (snd) snd.addEventListener('click', function (e) {
        e.stopPropagation(); v.muted = !v.muted; box.classList.toggle('is-snd', !v.muted);
        if (snd.tagName === 'BUTTON' && !snd.querySelector('svg')) snd.textContent = v.muted ? 'Sesi aç' : 'Sesi kapat';
        snd.setAttribute('aria-label', v.muted ? 'Sesi aç' : 'Sesi kapat'); if (v.paused) play(v);
      });
      function open() { v.pause(); if (d.showModal) { d.showModal(); f.currentTime = 0; f.muted = false; play(f); } else { window.location.href = f.querySelector('source').src; } }
      function close() { f.pause(); d.close(); play(v); }
      box.querySelectorAll('[data-msb-vid-open]').forEach(function (b) { b.addEventListener('click', open); });
      if (!box.classList.contains('msb-pm__vid--a')) v.addEventListener('click', open);
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-msb-vid-x]')) close(); });
      d.addEventListener('cancel', function () { f.pause(); play(v); });
    }
    function all() { document.querySelectorAll('[data-msb-vid]').forEach(initVid); }
    if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-product-similar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(el) {
      if (el.dataset.msbInit || el.querySelector('.msbd-in')) return;
      el.dataset.msbInit = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-msb-sim]');
        if (fresh && fresh.querySelector('.msbd-in')) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    }
    function initAll() { document.querySelectorAll('[data-msb-sim]').forEach(load); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msb-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.msbInit) return;
      root.dataset.msbInit = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.msb-tabs__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.msb-tabs__panel'));
      function show(i) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            show(n); tabs[n].focus();
          }
        });
      });
    }
    function initAll() { document.querySelectorAll('[data-msb-tabs]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
